module.exports = __webpack_public_path__ + "img/pan-tool-white.99f22202.svg";